import React from 'react';

export default function Toast({ toast }) {
  if (!toast) return null;
  return (
    <div style={{ position: "fixed", top: 16, left: "50%", transform: "translateX(-50%)", zIndex: 300, background: toast.t === "error" ? "#ff1744" : "#00e676", color: toast.t === "error" ? "#fff" : "#000", padding: "10px 20px", borderRadius: 8, fontSize: 12, fontFamily: "JetBrains Mono", fontWeight: 700, animation: "toastIn .2s ease", boxShadow: "0 4px 20px #0008" }}>{toast.m}</div>
  );
}
